<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==1">
  <div class="container text-center">
    <i class="fa fa-spinner fa-spin" style="font-size:48px;color:darkseagreen"></i> <p>{{'app.Loading' | translate}}</p>
  </div>
</div>

<div class="col-sm-12" *ngIf="displayMode==2">
  <p class="links-summary" *ngIf="viewerHasArea">
    {{'hcps.linkedHcosSummary' | translate:{ total: links.length, inside: insideCount, outside: links.length - insideCount } }}
  </p>
  <p class="links-summary" *ngIf="!viewerHasArea">
    {{'hcps.linkedHcosCount' | translate:{ total: links.length } }}
  </p>
  <table class="table table-bordered links-table">
    <thead>
      <tr>
        <th>Id</th>
        <th>{{'hcps.hco' | translate}}</th>
        <th>{{'pageHeader.BrickName' | translate}}</th>
        <th>{{'pageHeader.OrganizationType' | translate}}</th>
        <th *ngIf="viewerHasArea">{{'hcps.area' | translate}}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let link of links" [class.inside-area]="viewerHasArea && link.inUserArea" [class.outside-area]="viewerHasArea && !link.inUserArea">
        <td>{{link.hcoId}}</td>
        <td>
          {{link.hcoName}}
          <span *ngIf="link.pendingDeleted" class="unlink-pending">({{'hcps.unlinkPending' | translate}})</span>
        </td>
        <td>{{link.hcoBrickName}}</td>
        <td>{{link.hcoOrganizationTypeName}}</td>
        <td *ngIf="viewerHasArea">
          <span *ngIf="link.inUserArea" class="label label-success">{{'hcps.insideYourArea' | translate}}</span>
          <span *ngIf="!link.inUserArea" class="label label-default">{{'hcps.outsideYourArea' | translate}}</span>
        </td>
      </tr>
      <tr *ngIf="links.length==0">
        <td [attr.colspan]="viewerHasArea ? 5 : 4">{{'hcps.noLinkedHcos' | translate}}</td>
      </tr>
    </tbody>
  </table>
  <div class="panel-footer margin-top-20">
    <button class="btn btn-cancel" type="button" (click)="back()">{{'Back' | translate}}</button>
  </div>
</div>

<div class="row col-sm-12 padding-sm-hr" *ngIf="displayMode==3">
  <div class="alert alert-danger alert-dark">
    {{'app.ServerError' |translate}}.
  </div>
</div>
